export const VENUES = 'VENUES';
export const VENUE = 'VENUE';
export const DELETE = 'DELETE';
export const SORT = 'SORT';
export const MORE = 'MORE';
export const LOADING = 'LOADING';
export const TOTAL = 'TOTAL';
export const CLEAR_ITEMS = 'CLEAR_ITEMS';
export const RESET_FILTER = 'RESET_FILTER';

export default {
  VENUES,
  VENUE,
  DELETE,
  SORT,
  MORE,
  LOADING,
  TOTAL,
  CLEAR_ITEMS,
  RESET_FILTER,
};
